import React, {Component} from 'react';
import {
  Dimensions,
  Platform,
  TouchableOpacity,
  View,
} from 'react-native';
import _ from 'lodash';
import {connect} from 'react-redux';
import CartRemovalConfirmModal, {buildCartRemovalMessage, getPreviewFailureMessage} from './cartRemovalPrompt';
import {StatusChangeOutcomeModal, getStatusChangeOutcome, getStatusFailureMessage} from './statusChangeModals';
import {SearchOrder, ResetSearchOrder, GetOrderList, UpdateOrderStatus, CartedOrdersPreview, ResetOrdersUpdated, GetAllTags, AssignOrdersToUsers, DeassignOrdersToUsers, UpdateOrderInfo, CreateOrder} from '../../actions/orderActions';
import {Text} from 'react-native-elements';
import {LinearGradient} from 'expo-linear-gradient';
import CommonStyles from '../../style/commonStyles';
import moment from 'moment';
import ReactDataGrid from '@inovua/reactdatagrid-community';
import Menu from '@inovua/reactdatagrid-community/packages/Menu';

import '@inovua/reactdatagrid-community/index.css';
import '@inovua/reactdatagrid-enterprise/theme/default-dark.css';
import OrderStatusDropdown from './orderStatusDropdown';
import SavedFavouriteViewsDropdown from './savedFavouriteViewsDropdown';
import '@inovua/reactdatagrid-enterprise/index.css'
import SelectFilter from '@inovua/reactdatagrid-community/SelectFilter'
import DateFilter from '@inovua/reactdatagrid-community/DateFilter'
import NumberFilter from '@inovua/reactdatagrid-community/NumberFilter'
import PopUpModel from '../scanpack/pop_up_model';
import i18n from 'i18n-js';
import AsyncStorage from '@react-native-async-storage/async-storage';
import axios from 'axios';
import SearchNotFoundPrompt from './searchNotFoundPrompt';


import UpdateOrdersDropDowns from './updateOrdersDropDowns';
import UpdateTagsDropDowns from './updateTagsDropDowns';
import { getStatus, loadTagsData } from './commonFunctions';
import OrderDateDropdown from './orderdDateDropdown';
import { DATE_SORT_OPTIONS, loadDateSortPreference } from '../../utils/dateSortPreferences';
import OrderSkusDropdown from './orderSkusDropdown';
import CustomScrollBar from '../../commons/customScrollBar';
import OrderTagsDropdown from './orderTagsDropdown';
import { ScrollView } from 'react-native-gesture-handler';
import OrderUserTagsDropdown from './orderUserTags';
import { OrderNumberCell } from './orderNumberCell';
import UserTagsDropdown from './userTagsDropdown';
import { getSelectedOrderIds, getSelectedOrders, getTagIdLabelArray, getTransformedList, getUpdatedSelectedList, getUserIdLabelArray, getUserName, priorityListDisplayToggle, processUserAndTagFilter } from '../../helpers/scanPackFunctions';
import { SelectAllButton } from './selectAllButton';
import { GetAllUsers } from '../../actions/userAction';
import { TagsCell } from './tagsCell';
import { NoteCell } from './noteCell';
import { PriorityListToggle } from './orderPriorityList/priorityListToggle';
import OrderTagPriorityContainer from './orderPriorityList/orderTagPriorityContainer';
import { GetTagPriorityList } from '../../actions/tagPriorityActions';
import SearchBar from './orderSearchList/searchBar';
import { DisableFiltersButton } from './orderSearchList/disableFiltersButton';
import { loadAwaitingWindowPreference } from '../../utils/awaitingWindowPreferences';
import { excludedTagData, filterValueData, formatItemData, getStatusesData, includedTagData, } from './orderSearchList/data';
import { buildLegacyOrderGridSearchParams, buildOrderGridQueryContract } from './orderSearchList/queryContract';
import Prompt from '../../commons/prompt';
import { ResetSearchOrderData } from '../../actions/scanpackAction';
import { getSkuSuggestions } from '../../actions/productAction';
import { loadColumnPreferences, updateColumnVisibility, updateColumnOrder, updateColumnWidth, applyColumnPreferences } from '../../utils/gridColumnPreferences';
import { getAutosizeColumnUpdates } from '../../utils/gridColumnAutosize';
import {SCANPACK_ORDER_WINDOW_NAME_PREFIX} from '../../constants';

const ORDER_SEARCH_LIST_GRID_ID = 'orderSearchList';

export const getScanPackOrderUrl = () => {
  const scanPackOrderUrl = new URL(window.location.href);
  scanPackOrderUrl.searchParams.delete('scanpack_order');
  return scanPackOrderUrl.toString();
};

export const getScanPackOrderWindowName = orderNumber =>
  `${SCANPACK_ORDER_WINDOW_NAME_PREFIX}${encodeURIComponent(orderNumber)}`;

export const getOrderStatusLabel = status => {
  const normalizedStatus = status?.toString()?.toLowerCase();

  switch (normalizedStatus) {
  case 'onhold':
    return 'Action Required';
  case 'pick_in_progress':
  case 'pickinprogress':
    return 'Pick in Progress';
  case 'picked':
    return 'Picked';
  case 'backordered':
    return 'Backordered';
  default:
    return status
      ? status.charAt(0).toUpperCase() + status.slice(1)
      : status;
  }
};

export const shouldShowSearchExpansionPrompt = searchMetadata =>
  Boolean(searchMetadata?.has_hidden_matches || searchMetadata?.hidden_count > 0);

export const getSearchExpansionPromptState = (searchMetadata, fallback = {}) => {
  if (shouldShowSearchExpansionPrompt(searchMetadata)) {
    return {
      visible: true,
      hiddenCount: Number(searchMetadata?.hidden_count) || 0
    };
  }

  const unfilteredCount = Number(fallback.unfilteredCount);
  const filteredCount = Number(fallback.filteredCount);
  const hiddenCount = unfilteredCount - filteredCount;
  const shouldUseFallback =
    Boolean(fallback.search) &&
    Number(fallback.activeFilterCount) > 0 &&
    Number.isFinite(unfilteredCount) &&
    Number.isFinite(filteredCount) &&
    hiddenCount > 0;

  return {
    visible: shouldUseFallback,
    hiddenCount: shouldUseFallback ? hiddenCount : 0
  };
};

export const getOrderGridActiveFilterCount = ({
  selectedStates = [],
  selectedTags = [],
  selectedUsers = [],
  selectedSkus = [],
  selectedDateMode
} = {}) => {
  let filterCount = 0;

  if ((selectedStates?.length || 0) > 0) filterCount++;
  if ((selectedTags?.length || 0) > 0) filterCount++;
  if ((selectedUsers?.length || 0) > 0) filterCount++;
  if ((selectedSkus?.length || 0) > 0) filterCount++;
  if (selectedDateMode?.length > 0 && selectedDateMode !== 'all_day') {
    filterCount++;
  }

  return filterCount;
};

export const getServerStatusCounts = responseData =>
  responseData?.orders_count || responseData?.returned_orders_count || {};

export const getServerQueryCounts = responseData => {
  const queryCounts =
    responseData?.returned_orders_count || responseData?.orders_count || {};

  return {
    ...queryCounts,
    filtered_count:
      responseData?.orders_count?.filtered_count ??
      responseData?.returned_orders_count?.filtered_count ??
      queryCounts.filtered_count
  };
};

// The orders panel is the rounded dark card that holds the sidebar + grid. It has
// to reach the bottom of the viewport, so its height is measured rather than
// guessed: we take where the card actually starts on screen and give it whatever
// is left, minus the gap that keeps its rounded bottom corner and drop shadow visible.
// GAP = the card's own marginBottom (10) + the page gradient's paddingBottom (15).
export const ORDER_GRID_PANEL_BOTTOM_GAP = 25;
export const ORDER_GRID_PANEL_MIN_HEIGHT = 320;
// react-native-web's Dimensions fires 'change' synchronously per native resize
// tick with no throttling of its own; without this, dragging a window edge
// re-renders the ~500-line render() on every tick. GROOV-5070.
export const RESIZE_MEASURE_DEBOUNCE_MS = 120;

export const getOrderGridPanelHeight = ({
  windowHeight,
  panelTop,
  bottomGap = ORDER_GRID_PANEL_BOTTOM_GAP,
  minHeight = ORDER_GRID_PANEL_MIN_HEIGHT
} = {}) => {
  if (!Number.isFinite(windowHeight) || !Number.isFinite(panelTop)) {
    return null;
  }

  return Math.max(minHeight, Math.floor(windowHeight - panelTop - bottomGap));
};

const normalizeSkuList = (list, kind = 'present') => {
  if (!Array.isArray(list)) return [];
  return list.map(item => {
    const name = item.sku ?? item.name;
    const count = item.order_count ?? item.not_present_in_order_count ?? 0;
    return kind === 'present'
      ? { name, text: name, order_count: count }
      : { name, text: name, not_present_in_order_count: count };
  });
};

let previousData = true;
let prevSkip = 0;
let update = false;
let updateSearch = false;
let shouldUpdateCount = true;
let isFirstCall = true;
let tags_status;
let isSearchOrder = false;
let islastSearchPresent = false;
let allOrders = [];
let allOrdersWithStatus = [];
let isValuePresentForAny = false;
let displayPrompt = false;
let prevlimit = 0;
let alertMessage = ''
let alertMessageIsInfo = false
let data = {}
let PresentFilterValues;
let unselectedOrderItems;
let FirstOrdersTagsStatus = true;
let isFirstTime = true;
let previousGridSelectionRef = undefined;
let dateValue = '14';
let currentSelectedDate = "14";
let dateRangeValues = {"start_date": '', "end_date": ''};
let filterIncludedTags = false;
let userAddedCount = null;
let isAllFiltersDisabled = false;

let includedTags = includedTagData

let excludedTags = excludedTagData

let includedSkus = []

let excludedSkus = []

let filterIncludedSkus = false;

let usersOrderCount = [];
let usersOrderAssignedCount = [];

const orderCount = {
  awaiting: 5,
  partially_scanned: 3,
  scanned: 8,
  cancelled: 2,
  serviceissue: 1,
  onhold: 4
};


window.moment = moment
export class OrderSearchList extends Component {
  constructor(props) {
    super(props);
    const initialStatus = props.route?.params?.initial_status || props.initial_status;
    
    this.state = {
      items: [],
      getAllItem: {
        filter: 'all',
        sort: '',
        order: 'DESC',
        is_kit: 0,
        limit: 20,
        offset: 0
      },
      searchData: {
        search: '',
        sort: '',
        order: 'DESC',
        is_kit: -1,
        limit: 20,
        offset: 0
      },
      // null until the panel has been measured on screen; see measureGridPanel.
      gridPanelHeight: null,
      usingPreFilteredData: false,
      allProduct: [],
      searchOrderCount: [],
      formattedItems: [],
      selected: [],
      searchProduct: [],
      existingItems: [],
      orderID: '',
      windowWidth: 0,
      checkWidth: 0,
      searchTxt: '',
      start: 0,
      end: 10,
      currentPage: 1,
      selectedRows: {},
      quickScanToolTip3: false,
      presentkitid: [],
      gridRef: null,
      gridResetVersion: 0,
      gridSortInfo: null,
      gridSelectionRef: null,
      selectedStates: initialStatus ? [initialStatus] : [],
      selectedTags: [],
      selectedUsers: [],
      selectedSkus: [],
      addedSkus: [],
      curretnDisplayItem: [],
      filteredItems: [],
      clearAllFilters: false,
      matchOption: 'Any',
      current_orders_count: undefined,
      liveOrderCount: undefined,
      inViewCount: undefined,
      popUpModelShow: false,
      currentOrdersCount: 0,
      isShiftPressed: false,
      displayPriorityList: false,
      selectedMenuId: 1,
      showPrompt: false,
      searchExpansionPrompt: {
        visible: false,
        hiddenCount: 0
      },
      searchFiltersApplied: false,
      ordersTagsStatus: undefined,
      dateSortField: loadDateSortPreference(props.userInfo),
      columnPreferencesRevision: 0,
      // "Select all" in the left-hand nav means "every order in the current
      // filtered view", not just the rows on the visible page. It drives the
      // select_all flag on every bulk-action payload, so it lives in component
      // state: a module-level variable neither re-renders the dropdowns that
      // read it nor resets when the screen is remounted.
      allOrdersSelected: false
    };
    const savedDays = loadAwaitingWindowPreference(props.userInfo);
    dateValue = savedDays;
    currentSelectedDate = savedDays;
    this.tooltipRef = React.createRef();
    this.searchField = React.createRef();
  }
  update = () => {
    this.setState({
      windowWidth: window.innerWidth
    });
  };

  handleShiftKey =(event)=>{
    if (event.shiftKey) {
      this.setState({isShiftPressed: true});
    } else {
      this.setState({isShiftPressed: false});
    }
  };

  handleDateSortChange = (newSortField) => {
    this.setState({ dateSortField: newSortField }, () => {
      this.refreshOrdersGrid('date-sort-change', {resetSelection: false});
    });
  };

  getCurrentFiltersSnapshot = () => {
    let gridFilters = [];
    try {
      if (PresentFilterValues) {
        gridFilters = JSON.parse(PresentFilterValues);
      }
    } catch (e) {
      gridFilters = [];
    }

    const dateRange = {...dateRangeValues};

    const statuses = this.state.selectedStates || [];
    const search = this.state.searchData?.search || '';
    const sortField =
      this.state.dateSortField === DATE_SORT_OPTIONS.UPDATED_IN_GP
        ? 'last_modified'
        : 'order_placed_time';
    const sortDirection = this.state.searchData?.order || 'DESC';
    const canonicalQuery = buildOrderGridQueryContract({
      dateValue,
      dateRange,
      filterValue: gridFilters,
      rawFilterValue: gridFilters,
      matchOption: this.state.matchOption,
      search,
      selectedStates: statuses,
      selectedTags: this.state.selectedTags || [],
      selectedSkus: this.state.selectedSkus || [],
      selectedUsers: this.state.selectedUsers || [],
      filterIncludedTags,
      filterIncludedSkus,
      sortField,
      sortOrder: sortDirection,
      skip: 0,
      limit: this.state.getAllItem?.limit || 20
    });

    return {
      version: 1,
      canonicalQuery,
      statuses,
      date: {
        mode: currentSelectedDate,
        value: currentSelectedDate === 'all_day' ? '' : dateValue,
        range: dateRange
      },
      search,
      tags: {
        values: this.state.selectedTags || [],
        include: filterIncludedTags
      },
      skus: {
        values: this.state.selectedSkus || [],
        added: this.state.addedSkus || [],
        include: filterIncludedSkus
      },
      users: {
        values: this.state.selectedUsers || []
      },
      gridFilters,
      sort: {
        field:
          this.state.dateSortField === DATE_SORT_OPTIONS.UPDATED_IN_GP
            ? 'updated_at'
            : 'order_placed_time',
        direction: this.state.searchData?.order || 'DESC'
      },
      meta: {
        match_option: this.state.matchOption,
        is_scanned_today_view: !!this.state.isScannedTodayView,
        is_all_filters_disabled: isAllFiltersDisabled
      }
    };
  };

  applySavedFiltersSnapshot = (snapshot) => {
    if (!snapshot || typeof snapshot !== 'object') return;

    update = false;
    const date = snapshot.date || {};
    const tags = snapshot.tags || {};
    const skus = snapshot.skus || {};
    const users = snapshot.users || {};
    const sort = snapshot.sort || {};
    const meta = snapshot.meta || {};

    const dateMode = date.mode ?? currentSelectedDate;
    if (dateMode === 'all_day') {
      currentSelectedDate = 'all_day';
      dateValue = '';
      dateRangeValues.start_date = '';
      dateRangeValues.end_date = '';
    } else if (dateMode === 'start_date' || dateMode === 'end_date') {
      currentSelectedDate = dateMode;
      dateValue = '';
      dateRangeValues.start_date = date.range?.start_date ?? '';
      dateRangeValues.end_date = date.range?.end_date ?? '';
    } else {
      currentSelectedDate = dateMode;
      dateValue = date.value ?? (typeof dateMode === 'string' && !isNaN(Number(dateMode)) ? dateMode : loadAwaitingWindowPreference(this.props.userInfo));
      dateRangeValues.start_date = '';
      dateRangeValues.end_date = '';
    }
    filterIncludedTags = tags.include ?? filterIncludedTags;
    filterIncludedSkus = skus.include ?? filterIncludedSkus;
    isAllFiltersDisabled = meta.is_all_filters_disabled ?? false;

    const gridFilters = Array.isArray(snapshot.gridFilters) ? snapshot.gridFilters : [];
    PresentFilterValues = gridFilters.length > 0 ? JSON.stringify(gridFilters) : undefined;

    const dateSortField =
      sort.field === 'updated_at' || sort.field === 'last_modified'
        ? DATE_SORT_OPTIONS.UPDATED_IN_GP
        : DATE_SORT_OPTIONS.ORDER_DATE;

    const searchData = {...this.state.searchData};
    if (snapshot.search != null) {
      searchData.search = snapshot.search;
    }
    if (sort.direction) {
      searchData.order = sort.direction;
    }

    this.setState(
      {
        selectedStates: Array.isArray(snapshot.statuses) ? snapshot.statuses : this.state.selectedStates,
        selectedTags: Array.isArray(tags.values) ? tags.values : this.state.selectedTags,
        selectedSkus: Array.isArray(skus.values) ? skus.values : this.state.selectedSkus,
        addedSkus: Array.isArray(skus.added) ? skus.added : this.state.addedSkus,
        selectedUsers: Array.isArray(users.values) ? users.values : this.state.selectedUsers,
        searchData,
        matchOption: meta.match_option ?? this.state.matchOption,
        isScannedTodayView: !!meta.is_scanned_today_view,
        dateSortField,
        clearAllFilters: false
      },
      () => {
        const grid = this.state.gridRef?.current;
        if (!grid) return;

        grid.clearAllFilters();

        const statuses = Array.isArray(snapshot.statuses) && snapshot.statuses.length > 0
          ? snapshot.statuses
          : null;
        grid.setColumnFilterValue('Status', statuses);

        gridFilters.forEach(f => {
          if (f && f.name != null && f.name !== 'Status' && f.name !== 'User') {
            const value = f.value !== undefined && f.value !== '' && (typeof f.value !== 'object' || (Array.isArray(f.value) ? f.value.length > 0 : true))
              ? f.value
              : null;
            grid.setColumnFilterValue(f.name, value);
          }
        });

        const savedUsers = Array.isArray(users.values) && users.values.length > 0 ? users.values : null;
        grid.setColumnFilterValue('User', savedUsers);

        setTimeout(() => {
          this.refreshOrdersGrid('saved-filter-apply');
        }, 50);
      }
    );
  };

  statuses = getStatusesData(this.props.bothSettings, this.props.settings)

  formatItems = (items) => {
    return items?.map((item, index) => ({
      id: index+1,
      currentItem: item,
      OrderNumber: item.ordernum?.toString(),
      Store: item.order_info?.store_name?.toString(),
      Notes: item?.order_info?.notes?.toString() || '',
      OrderDate: item.order_info?.order_date,
      UpdatedInGP: item.order_info?.updated_at,
      Items: item.order_info?.itemslength,
      User: getUserName(
        item.order_info?.assigned_user_id,
        usersOrderAssignedCount
      ),
      Status: getOrderStatusLabel(item.order_info?.status)?.toString(),
      Tags: item.order_info?.tags?.length,
      order_id: item.order_info?.order_id,
      Recipient: item.order_info?.recipient,
      OSLMT:item.order_info?.last_modified,
      customFieldOne: item.order_info?.custom_field_one,
      customFieldTwo: item.order_info?.custom_field_two, //'country', 'city', 'email'
      trackingNumber: item.order_info?.tracking_num,
      country: item.order_info?.country,
      city: item.order_info?.city,
      email: item.order_info?.email,
      tote: item.tote,
    }));
  }
  componentWillUnmount () {
    this.props.ResetSearchOrderData();
  }

  filterValue = filterValueData(this.props.initial_status || '')

  sortColumnNames = {
    Items: 'itemslength',
    Store: 'store_name',
    Notes: 'notes_internal',
    OrderDate: 'order_placed_time',
    UpdatedInGP: 'updated_at',
    OrderNumber: 'increment_id',
    Recipient: 'firstname',
    OSLMT: 'last_modified',
    Status: 'status',
    User: 'user',
    Tags: 'tags',
    customFieldOne: 'custom_field_one',
    customFieldTwo: 'custom_field_two',
    trackingNumber: 'tracking_num',
    country: 'country',
    city: 'city',
    email: 'email',
    tote: 'tote'
  };
  orderSearchList
  columns = [
    {
      name: 'OrderNumber',
      header: 'Order Number',
      maxWidth: 1000,
      defaultFlex: 3,
      showColumnMenuSortOptions: false,
      render: ({value}, {cellProps}) => {
        const item = cellProps.data.currentItem;
        return (
          <OrderNumberCell
            item={item}
            value={value}
            redirectToProductDetail={this.redirectToProductDetail}
            redirectToScanPack={this.redirectToScanPackItem}
          />
        );
      }
    },
    {
      name: 'Store',
      header: 'Store',
      maxWidth: 1000,
      defaultFlex: 2,
      showColumnMenuSortOptions: false
    },
    {
      name: 'Notes',
      header: 'Notes',
      maxWidth: 1000,
      showColumnMenuSortOptions: false,
      defaultFlex: 2,
      render: ({value, cellProps}) => {
        const orderId = cellProps?.data?.currentItem?.order_info?.id;
        return <NoteCell key={orderId} value={value} orderId={orderId} updateOrderInfo={this.props.UpdateOrderInfo} />;
      }
    },
    {
      name: 'OrderDate',
      header: 'OrderDate',
      dateFormat: 'MM-DD-YYYY',
      filterEditor: DateFilter,
      maxWidth: 1000,
      defaultFlex: 2,
      filterEditorProps: (props, {index}) => {
        return {
          dateFormat: 'MM-DD-YYYY',
          placeholder:
            index == 1
              ? 'Source modified time is before...'
              : 'Source modified time is after...'
        };
      },
      render: ({value, cellProps: {dateFormat}}) =>
        moment(value).format(dateFormat)
    },
    {
      name: 'UpdatedInGP',
      header: 'Updated in GP',
      dateFormat: 'MM-DD-YYYY h:mma',
      minWidth: 170,
      maxWidth: 1000,
      defaultFlex: 2,
      render: ({value, cellProps: {dateFormat}}) =>
        value ? moment(value).format(dateFormat) : ''
    },
    {
      name: 'Items',
      header: 'Items',
      maxWidth: 1000,
      type: 'number',
      defaultFlex: 2,
      showColumnMenuSortOptions: false,
      filterEditor: NumberFilter
    },
    {
      name: 'User',
      header: 'User',
      maxWidth: 1000,
      type: 'number',
      defaultFlex: 2,
      filterEditor: SelectFilter,
      filterEditorProps: {
        multiple: true,
        wrapMultiple: false,
        placeholder: 'All users',
        dataSource: getUserIdLabelArray(this.props.users || [])
      }
    },
    {
      name: 'Status',
      header: 'Status',
      maxWidth: 800,
      defaultFlex: 2,
      showColumnMenuSortOptions: false,
      filterEditor: SelectFilter,
      filterEditorProps: {
        multiple: true,
        wrapMultiple: false,
        placeholder: 'All',
        dataSource: this.statuses
      }
    },
    {
      name: 'Tags',
      header: 'Tags',
      maxWidth: 800,
      defaultFlex: 2,
      filterEditor: SelectFilter,
      filterEditorProps: {
        multiple: false,
        wrapMultiple: false,
        placeholder: 'All',
        dataSource: getTagIdLabelArray(this.props.ordersTags)
      },
      render: ({cellProps}) => {
        const item = cellProps.data.currentItem;
        return <TagsCell item={item} />;
      }
    },
    {
      name: 'Recipient',
      header: 'Recipient',
      maxWidth: 800,
      defaultFlex: 2,
      showColumnMenuSortOptions: false
    },
    {
      name: 'OSLMT',
      header: 'OSLMT',
      dateFormat: 'ddd MM/DD/YYYY h:mma',
      filterEditor: DateFilter,
      maxWidth: 1000,
      defaultFlex: 2,
      defaultVisible: false,
      filterEditorProps: (props, {index}) => {
        return {
          dateFormat: 'ddd MM/DD/YYYY h:mma',
          placeholder:
            index == 1
              ? 'Created date is before...'
              : 'Created date is after...'
        };
      },
      render: ({value, cellProps: {dateFormat}}) =>
        value ? moment(value).format(dateFormat) : ""
    },
    {
      name: 'customFieldOne',
      header: 'Custom Field One',
      maxWidth: 1000,
      defaultFlex: 2,
      showColumnMenuSortOptions: false,
      defaultVisible: false
    },
    {
      name: 'customFieldTwo',
      header: 'Custom Field Two',
      maxWidth: 1000,
      defaultFlex: 2,
      showColumnMenuSortOptions: false,
      defaultVisible: false
    },
    {
      name: 'trackingNumber',
      header: 'Tracking Number',
      maxWidth: 1000,
      defaultFlex: 2,
      showColumnMenuSortOptions: false,
      defaultVisible: false
    },
    {
      name: 'country',
      header: 'Country',
      maxWidth: 1000,
      defaultFlex: 2,
      showColumnMenuSortOptions: false,
      defaultVisible: false
    },
    {
      name: 'city',
      header: 'City',
      maxWidth: 1000,
      defaultFlex: 2,
      showColumnMenuSortOptions: false,
      defaultVisible: false
    },
    {
      name: 'email',
      header: 'Email',
      maxWidth: 1000,
      defaultFlex: 2,
      showColumnMenuSortOptions: false,
      defaultVisible: false
    },
    {
      name: 'tote',
      header: 'Tote',
      maxWidth: 1000,
      defaultFlex: 2,
      showColumnMenuSortOptions: false,
      defaultVisible: false
    }
  ];
  // `flex: 1` (not a percentage height) so the grid consumes exactly the space the
  // panel has left after its own toolbar row. A percentage of the panel ignored the
  // toolbar and pushed the grid's rounded bottom edge past the card. minHeight keeps
  // the grid usable if the viewport is too short for the panel's minimum.
  gridStyle = {minHeight: 200, width: '95%', alignSelf: 'start', flex: 1};

  gridPanelRef = React.createRef();

  // Measure where the panel actually starts on screen and give it the rest of the
  // viewport. Runs on mount, on any layout change of the panel itself (the bulk-action
  // bar above it appears and disappears with selection), and on window resize.
  measureGridPanel = () => {
    const node = this.gridPanelRef.current;
    const panelTop = node?.getBoundingClientRect?.().top;
    const windowHeight = Dimensions.get('window')?.height;
    const gridPanelHeight = getOrderGridPanelHeight({windowHeight, panelTop});

    if (gridPanelHeight !== null && gridPanelHeight !== this.state.gridPanelHeight) {
      this.setState({gridPanelHeight});
    }
  };

  handleWindowResize = () => {
    clearTimeout(this.resizeDebounceTimer);
    this.resizeDebounceTimer = setTimeout(this.measureGridPanel, RESIZE_MEASURE_DEBOUNCE_MS);
  };

  getColumnsWithPreferences = () => {
    const revision = this.state.columnPreferencesRevision || 0;
    if (this._columnsCache && this._columnsCacheRevision === revision) {
      return this._columnsCache;
    }
    const preferences = loadColumnPreferences(ORDER_SEARCH_LIST_GRID_ID, this.props.userInfo);
    this._columnsCache = preferences
      ? applyColumnPreferences(this.columns, preferences)
      : this.columns;
    this._columnsCacheRevision = revision;
    return this._columnsCache;
  };

  handleColumnVisibleChange = ({ column, visible }) => {
    if (column?.name) {
      updateColumnVisibility(
        ORDER_SEARCH_LIST_GRID_ID,
        this.props.userInfo,
        column.name,
        visible
      );
      this.setState(prevState => ({
        columnPreferencesRevision: prevState.columnPreferencesRevision + 1
      }));
    }
  };

  handleColumnOrderChange = (columnOrder) => {
    if (Array.isArray(columnOrder)) {
      const columnNames = columnOrder.map(col =>
        typeof col === 'string' ? col : col.name
      ).filter(Boolean);
      updateColumnOrder(
        ORDER_SEARCH_LIST_GRID_ID,
        this.props.userInfo,
        columnNames
      );
      this.setState(prevState => ({
        columnPreferencesRevision: prevState.columnPreferencesRevision + 1
      }));
    }
  };

  handleColumnResize = ({ column, width, size }) => {
    if (column?.name) {
      updateColumnWidth(
        ORDER_SEARCH_LIST_GRID_ID,
        this.props.userInfo,
        column.name,
        width ?? size
      );
      this.setState(prevState => ({
        columnPreferencesRevision: prevState.columnPreferencesRevision + 1
      }));
    }
  };

  applyColumnWidthUpdates = updates => {
    if (!updates?.length) return;

    updates.forEach(({column, width}) => {
      if (column?.name) {
        updateColumnWidth(
          ORDER_SEARCH_LIST_GRID_ID,
          this.props.userInfo,
          column.name,
          width
        );
      }
    });
    this.setState(prevState => ({
      columnPreferencesRevision: prevState.columnPreferencesRevision + 1
    }));
  };

  renderColumnContextMenu = (menuProps, menuContext) => {
    const items = (menuProps.items || []).map(item => {
      const autosizeMode =
        item?.itemId === 'autoSizeToFit'
          ? 'fit'
          : item?.itemId === 'autoresizeThisColumn'
          ? 'this'
          : item?.itemId === 'autoresizeAllColumns'
          ? 'all'
          : null;

      if (!autosizeMode) return item;

      return {
        ...item,
        onClick: () => {
          const updates = getAutosizeColumnUpdates(
            menuContext.computedProps,
            menuContext.cellProps?.id,
            autosizeMode
          );
          this.applyColumnWidthUpdates(updates);
          menuContext.computedProps?.hideColumnContextMenu?.();
        }
      };
    });

    return <Menu {...menuProps} items={items} />;
  };

  componentDidMount() {
    this.measureGridPanel();
    this.dimensionsSubscription = Dimensions.addEventListener(
      'change',
      this.handleWindowResize
    );
    window.addEventListener('resize', this.update);
    document.addEventListener('keydown', this.handleShiftKey, false);
    document.addEventListener('keyup', this.handleShiftKey, false);

    const savedDays = loadAwaitingWindowPreference(this.props.userInfo);
    dateValue = savedDays;
    currentSelectedDate = savedDays;

    const preFilteredData = this.props.route?.params?.preFilteredData;
    const initialStatus = this.props.route?.params?.initial_status;
    const isScannedToday = this.props.route?.params?.isScannedToday;
    const dateFilter = this.props.route?.params?.dateFilter;

    if (preFilteredData && initialStatus) {
      const formattedItems = this.formatItems(preFilteredData.orders) || [];
      const count = preFilteredData.orders_count?.filtered_count || preFilteredData.orders?.length || 0;

      allOrders = preFilteredData.orders || [];
      allOrdersWithStatus = formattedItems;

      if (dateFilter === 'all_day') {
        dateValue = '';
        currentSelectedDate = 'all_day';
        dateRangeValues = {"start_date": '', "end_date": ''};
      }

      const stateUpdate = {
        selectedStates: [initialStatus],
        formattedItems: formattedItems,
        currentOrdersCount: count,
        current_orders_count: preFilteredData.orders_count,
        usingPreFilteredData: true
      };

      if (isScannedToday) {
        stateUpdate.isScannedTodayView = true;
        stateUpdate.clearAllFilters = true;
        stateUpdate.selectedTags = [];
        stateUpdate.selectedUsers = [];
      }

      this.setState(stateUpdate);

      this.preFilteredResult = {
        data: formattedItems,
        count: count
      };

      setTimeout(() => {
        this.state.gridRef?.current?.setColumnFilterValue('Status', [initialStatus]);
      }, 100);

      return;
    }
    
    this.searchField.current?.focus();
    this.setState({allProduct: this.props.productSearchList});
    this.update();
    let product = this.props.product;

    if (product) {
      let existingItems = [];
      this.props?.items?.items.map((item, index) => {
        existingItems.push(item.productinfo.id);
      });
      this.setState({existingItems});
      this.props.GetAllProduct(this.state.getAllItem);
    }
    if (this.props?.items?.items?.length) {
      let sorted = this.props.items.items.sort(
        (a, b) =>
          Date.parse(a.iteminfo?.updated_at) -
          Date.parse(b.iteminfo?.updated_at)
      );
      this.setState({items: sorted});
    }
    this.state.searchData['search'] = this.props.lastSearched;
    this.searchField.current?.focus();
    !this.props.users && this.props.GetAllUsers();
    this.props.GetTagPriorityList();

    this._focusUnsubscribe = this.props.navigation?.addListener?.('focus', () => {
      this.refreshOrdersGrid('screen-focus', {resetSelection: false});
    });
  }

  async componentDidUpdate() {
    if (
      updateSearch === false &&
      this.props.searchProduct &&
      this.props.searchOrderCount &&
      !_.isEqual(this.state.searchProduct, this.props.searchProduct) &&
      !_.isEqual(this.state.searchOrderCount, this.props.searchOrderCount)
    ) {
      let temp = this.state.searchData;
      this.setState({
        allProduct: this.props.searchProduct,
        searchProduct: this.props.searchProduct,
        searchOrderCount: this.props.searchOrderCount,
        temp
      });
      updateSearch = true;
      isSearchOrder = true;
    }
    // this.searchField.current?.focus();
    // const isJobCompleted = await AsyncStorage.getItem('status_update_inprogress');
    // console.log(">>>>>>.ordersTags", this.props?.ordersTags)

    if (this.props.ordersUpdated) {
      // Keep the selection after a tag change so the Add/Remove Tags dropdown stays open.
      const isTagUpdate = this.props.ordersUpdated?.activity === 'tags_update';
      await this.props.ResetOrdersUpdated();
      await this.refreshOrdersGrid('orders-updated', {
        resetSelection: !isTagUpdate,
        delay: 0
      });
      this.setState({currentOrdersCount: 0});
      await AsyncStorage.setItem('progress', JSON.stringify(0));
      userAddedCount = null;
    }
  }

  componentWillUnmount () {
    this._focusUnsubscribe?.();
    clearTimeout(this.resizeDebounceTimer);
    if (this.dimensionsSubscription?.remove) {
      this.dimensionsSubscription.remove();
    } else if (Dimensions.removeEventListener) {
      Dimensions.removeEventListener('change', this.handleWindowResize);
    }
    this.dimensionsSubscription = null;
    window.removeEventListener('resize', this.update);
    document.removeEventListener('keydown', this.handleShiftKey, false);
    document.removeEventListener('keyup', this.handleShiftKey, false);
    clearTimeout(this.selectAllAfterSkipTimer);
    this.props.ResetSearchOrderData();
    this.preFilteredResult = null;
    allOrders = [];
    allOrdersWithStatus = [];
  }

  searchItem() {
    update = true;
    let search = this.state.searchData;
    if (search.search !== '') {
      updateSearch = false;
      this.setState(
        {
          searchFiltersApplied: false,
          selectedStates: [],
          selectedTags: [],
          selectedUsers: [],
          selectedSkus: [],
          addedSkus: [],
          isScannedTodayView: false,
          clearAllFilters: true,
          searchExpansionPrompt: {
            visible: false,
            hiddenCount: 0
          }
        },
        () => {
          this.refreshOrdersGrid('search', {
            resetSelection: false,
            delay: 100
          });
        }
      );
    }
  }

  redirectToProductDetail = (order, fromGrid) => {
    let page = this.props.fromPage ? this.props.fromPage : 'OrderSearch';

    const currentOrderIndex = allOrders.findIndex(o => o.id === order?.id);

    this.props.navigation.navigate('OrderDetail', {
      item: order,
      userData: this.props.userInfo,
      page: page,
      onComeBack: () => this.props.onComeBack(),
      isFromGrid: fromGrid,
      ordersList: allOrders,
      currentOrderIndex: currentOrderIndex >= 0 ? currentOrderIndex : 0
    });
    this.props.ResetSearchOrder()
  };

  redirectToScanPackItem = order => {
   
    if (
      Platform.OS === 'web' &&
      typeof window !== 'undefined' &&
      window.open &&
      order?.ordernum
    ) {
      const scanPackWindow = window.open('', '_blank');
      if (scanPackWindow) {
        scanPackWindow.name = getScanPackOrderWindowName(order.ordernum);
        scanPackWindow.opener = null;
        scanPackWindow.location.href = getScanPackOrderUrl();
        return;
      }
    }

    this.props.navigation.navigate('ScanPack', {
      orderNumber: order.ordernum,
      userdata: this?.props?.userInfo,
      page: 'orderSearchList'
    });
  }

  refreshOrdersGrid = async (reason, options = {}) => {
    const {
      resetSelection = true,
      deselect = resetSelection,
      data,
      delay = 0,
      reload: shouldReload = true
    } = options;
    const grid = this.state.gridRef?.current;
    this.lastRefreshReason = reason;

    if (deselect) {
      grid?.deselectAll?.();
    }
    // A refresh means the filtered view itself is changing (filters, search,
    // date range, a completed bulk action). "Every order in the view" no longer
    // describes what the user picked, so drop it. Leaving it set would silently
    // widen the next bulk action to the new, larger result set.
    if (this.state.allOrdersSelected) {
      this.setState({allOrdersSelected: false});
    }
    if (resetSelection) {
      this.handleResetFilter();
    }
    if (data) {
      await this.props.GetOrderList(data);
    }
    if (!grid || !shouldReload) {
      return;
    }

    const reload = () => grid.reload?.();

    if (delay > 0) {
      setTimeout(reload, delay);
      return;
    }

    reload();
  };

  handleGridFilterValueChange = filterValue => {
    const userFilter = filterValue?.find(f => f.name === 'User');
    const next = Array.isArray(userFilter?.value)
      ? userFilter.value.filter(Boolean)
      : (userFilter?.value ? [userFilter.value] : []);
    const current = this.state.selectedUsers || [];
    if (JSON.stringify(next) !== JSON.stringify(current)) {
      this.setState({selectedUsers: next});
    }
  };

  reloadGridOrders = async data => {
    await this.refreshOrdersGrid('bulk-list-action', {
      resetSelection: false,
      data,
      delay: 1000
    });
  };

  getUnselectedItemsFormattedIds = () => {
    const { gridSelectionRef, formattedItems } = this.state;
    // console.log(">>>>>>>>>>>>.gridSelectionRef", gridSelectionRef?.unselected, allOrdersWithStatus)
    if (gridSelectionRef?.unselected) {
      const unselectedIds = Object.keys(gridSelectionRef.unselected)
        .filter(key => gridSelectionRef.unselected[key])
        .map(Number);

        unselectedOrderItems = allOrdersWithStatus
        ?.map((item, index) => ({ id: item.currentItem.id, index, objectId: item.id }))
        .filter(item => unselectedIds.includes(item.objectId))
        .map(item => item.id) // Extract the id
        .join(',');
        return unselectedOrderItems;
    } else {
      unselectedOrderItems = ""
      return unselectedOrderItems;
    }
  }

  updateOrderStatus = async (value) => {
    let gridSelectionIdsArray = getSelectedOrderIds(this.state.selectedRows)

    const unselectedItems = this.getUnselectedItemsFormattedIds();
    const lowerCaseStatesString = this.state.selectedStates
      ?.map(state => state.toLowerCase())
      .join(',');
    let parsedFilterValues = [];
    try {
      parsedFilterValues = JSON.parse(PresentFilterValues) || [];
    } catch (error) {
      parsedFilterValues = [];
    }
    const {updatedFilterValue} = processUserAndTagFilter([...parsedFilterValues], includedTags, filterIncludedTags, includedSkus, filterIncludedSkus);
    data = {
      filter: lowerCaseStatesString || 'all',
      inverted: false,
      limit: 20,
      offset: prevSkip,
      order: 'DESC',
      orderArray: gridSelectionIdsArray,
      product_search_toggle: 'true',
      reallocate_inventory: true,
      search: this.state.searchData?.search || '',
      filters: updatedFilterValue,
      select_all: this.state.allOrdersSelected,
      dateValue:dateValue,
      dateRange: JSON.stringify(dateRangeValues),
      username: (this.state.selectedUsers || []).join(','),
      tags_name: (this.state.selectedTags || []).join(','),
      filterIncludedTags: filterIncludedTags,
      skus_name: this.state.selectedSkus || [],
      filterIncludedSkus: filterIncludedSkus,
      match_option: this.state.matchOption,
      sort: '',
      status: value,
      unselected: unselectedItems
    };
    // console.log("gridSelectionRef", this.state.gridSelectionRef)
    if (this.statusChangeBusy) return;
    this.statusChangeBusy = true;
    try {
      const preview = await this.props.CartedOrdersPreview(data);
      if (!preview.ok) {
        this.alertBox(getPreviewFailureMessage(preview), false);
        return;
      }
      if (Number(preview.data?.carted_count) > 0) {
        this.setState({
          cartRemovalPrompt: {
            data,
            message: buildCartRemovalMessage(
              preview.data,
              !data.select_all && data.orderArray.length === 1
            )
          }
        });
        return;
      }
      await this.sendStatusChange(data);
    } finally {
      this.statusChangeBusy = false;
    }
  };

  refreshAfterStatusChange = () =>
    this.refreshOrdersGrid('status-update-submitted', {resetSelection: true});

  sendStatusChange = async data => {
    const result = await this.props.UpdateOrderStatus(data);
    if (!result.ok) {
      this.alertBox(getStatusFailureMessage(result), false);
    }
    const outcome = getStatusChangeOutcome(result);
    if (outcome.totes.length > 0 || outcome.notChanged.length > 0) {
      this.setState({statusChangeOutcome: outcome});
    }
    if (outcome.totes.length === 0) {
      await this.refreshAfterStatusChange();
    }
  };

  acknowledgeTotes = async () => {
    const {notChanged} = this.state.statusChangeOutcome;
    this.setState({statusChangeOutcome: {totes: [], notChanged}});
    await this.refreshAfterStatusChange();
  };

  acknowledgeNotChanged = () => {
    this.setState({statusChangeOutcome: null});
  };

  confirmCartRemoval = async () => {
    const {data} = this.state.cartRemovalPrompt;
    this.setState({cartRemovalPrompt: null});
    this.statusChangeBusy = true;
    try {
      await this.sendStatusChange(data);
    } finally {
      this.statusChangeBusy = false;
    }
  };

  cancelCartRemoval = () => {
    this.setState({cartRemovalPrompt: null});
  };

  distributeOrders = (selectedCountofOrders, usersSelected) => {
    const numberOfUsers = usersSelected.length;
    const baseCount = Math.floor(selectedCountofOrders / numberOfUsers); // Get the base number of orders per user
    let remainingOrders = selectedCountofOrders % numberOfUsers; // Get the remaining orders that need to be distributed

    return usersSelected.map((user, index) => {
      // Distribute the highest number of remaining orders to the first user
      const assignedOrders = baseCount + (index < remainingOrders ? 1 : 0); // The first 'remainingOrders' users get 1 extra order
      return {
        user,
        assignedOrders,
      };
    });
  };

  assignOrdersToUsers = async (
    usersSelected,
    shoudlAssign = true,
    selectedCountofOrders,
    clearAllAssignment = false
  ) => {
    if (!getSelectedOrders(this.state.selectedRows)?.length > 0) {
      this.alertBox(i18n.t('order.noSelectedUserError'));
      return;
    }
    // Clearing every assignment is by definition an action on the whole
    // filtered view, so it opts in explicitly rather than by poking a shared
    // flag before calling in.
    const selectAllInView = this.state.allOrdersSelected || clearAllAssignment;
    let gridSelectionIdsArray = getSelectedOrderIds(this.state.selectedRows);
    const unselectedItems = this.getUnselectedItemsFormattedIds();

    const lowerCaseStatesString = this.state.selectedStates
      ? this.state.selectedStates.map(state => state.toLowerCase()).join(',')
      : null;
    let parsedFilterValues = [];
    try {
      parsedFilterValues = JSON.parse(PresentFilterValues) || [];
    } catch (error) {
      parsedFilterValues = [];
    }
    const {updatedFilterValue} = processUserAndTagFilter([...parsedFilterValues], includedTags, filterIncludedTags, includedSkus, filterIncludedSkus);
    data = {
      filter: lowerCaseStatesString || 'all',
      inverted: false,
      limit: 20,
      offset: prevSkip,
      order: 'DESC',
      orderArray: gridSelectionIdsArray,
      product_search_toggle: 'true',
      reallocate_inventory: true,
      search: this.state.searchData?.search || '',
      filters: updatedFilterValue,
      select_all: selectAllInView,
      dateValue:dateValue,
      dateRange: JSON.stringify(dateRangeValues),
      username: (this.state.selectedUsers || []).filter(user => user !== 'unassigned').join(','),
      tags_name: (this.state.selectedTags || []).join(','),
      filterIncludedTags: filterIncludedTags,
      skus_name: this.state.selectedSkus || [],
      filterIncludedSkus: filterIncludedSkus,
      match_option: this.state.matchOption,
      sort: '',
      unselected: unselectedItems,
      users: usersSelected,
      dateValue: dateValue,
      // username: this.state.selectedUsers
    };

    if (this.state.allOrdersSelected) {
      this.setState({allOrdersSelected: false});
    }
    if (gridSelectionIdsArray.length >= usersSelected.length || clearAllAssignment) {
      (await shoudlAssign) === true
        ? this.props.AssignOrdersToUsers(data)
        : this.props.DeassignOrdersToUsers(data);
    } else {
      this.alertBox(i18n.t('order.selectedUserError'));
    }
    userAddedCount =  shoudlAssign === true ? this.distributeOrders(selectedCountofOrders, usersSelected) : null
    // this.state.gridRef?.current.deselectAll();
    // this.handleResetFilter();
    this.props.GetTagPriorityList()
  };

  handleChange(text) {
    let searchData = this.state.searchData;
    searchData['search'] = text;
    this.setState({searchData});
  }

  clearSearch = () => {
    displayPrompt = false;
    updateSearch = false;
    isSearchOrder = false;
    islastSearchPresent = false;

    const searchData = {
      ...this.state.searchData,
      search: ''
    };

    this.setState(
      {
        searchData,
        searchTxt: '',
        searchProduct: [],
        searchOrderCount: [],
        searchFiltersApplied: false,
        current_orders_count: this.props.orderCount,
        searchExpansionPrompt: {
          visible: false,
          hiddenCount: 0
        }
      },
      () => {
        this.refreshOrdersGrid('search-clear', {
          resetSelection: false,
          delay: 0
        });
      }
    );
  };

  getActiveFilterCount = () => getOrderGridActiveFilterCount({
    selectedStates: this.state.selectedStates,
    selectedTags: this.state.selectedTags,
    selectedUsers: this.state.selectedUsers,
    selectedSkus: this.state.selectedSkus,
    selectedDateMode: currentSelectedDate
  });

  shouldShowApplySearchFiltersButton = () =>
    Boolean(this.state.searchData?.search) &&
    !this.state.searchFiltersApplied &&
    this.getActiveFilterCount() > 0;

  applyCurrentFiltersToSearch = () => {
    this.setState(
      {
        searchFiltersApplied: true,
        searchExpansionPrompt: {
          visible: false,
          hiddenCount: 0
        }
      },
      () => {
        this.refreshOrdersGrid('search-apply-current-filters', {
          resetSelection: false,
          delay: 0
        });
      }
    );
  };

  closeAlert = () => {
    this.setState({popUpModelShow: false});
  };

  alertBox = (message, isInfo = false) => {
    alertMessage = message
    alertMessageIsInfo = isInfo
    this.setState({popUpModelShow: true});
    setTimeout(
      function () {
        this.setState({
          popUpModelShow: false
        });
      }.bind(this),
      4000
    );
  };
  Capitalize(str) {
    return str?.charAt(0)?.toUpperCase() + str?.slice(1);
  }

  getFilteredOrders = (selectedStatuses, shouldRefreshGrid = false) => {
    const isScannedTodaySelected = selectedStatuses?.includes('ScannedToday');
    const gridStatusFilterValue = Array.isArray(selectedStatuses) && selectedStatuses.length === 1
      ? selectedStatuses[0]
      : selectedStatuses;

    if (this.state.usingPreFilteredData) {
      this.preFilteredResult = null;
    }

    this.setState(
      {
        selectedStates: selectedStatuses,
        formattedItems: [],
        isScannedTodayView: isScannedTodaySelected,
        usingPreFilteredData: false
      },
      () => {
        this.state.gridRef?.current?.setColumnFilterValue?.(
          'Status',
          gridStatusFilterValue
        );

        if (shouldRefreshGrid) {
          this.refreshOrdersGrid('status-filter-select', {
            resetSelection: true,
            reload: false
          });
        }
      }
    );
  };

  getScannedTodayOrders = async () => {
    this.setState({
      selectedStates: ['ScannedToday'],
      formattedItems: [],
      isScannedTodayView: true,
      clearAllFilters: true,
      selectedTags: [],
      selectedUsers: [],
      selectedSkus: [],
      addedSkus: []
    }, () => {
      this.refreshOrdersGrid('scanned-today');
    });
  };

  getScannedTodayOrders = async() => {
    this.setState({
      selectedStates: ['ScannedToday'],
      formattedItems: [],
      isScannedTodayView: true,
      clearAllFilters: true,
      selectedTags: [],
      selectedUsers: [],
      selectedSkus: [],
      addedSkus: []
    }, () => {
      this.state.gridRef?.current.deselectAll();
      this.state.gridRef?.current.reload();
    });
  };

  loadTagsData = async() => {
    const selectedStates = this.state.selectedStates;
    const gridSelectionRef = this.state.gridSelectionRef;
    const ordersTags = this.props.ordersTags;
    const prevlimit = this.state.prevlimit;
    const prevSkip = this.state.prevSkip;
    const searchData = this.state.searchData;
    const selectedOrders = this.state.selectedRows;
    const tags_selected = this.state.selectedTags

    try {
      const ordersTagsStatus = await loadTagsData({
        selectedStates,
        gridSelectionRef,
        ordersTags,
        prevlimit,
        prevSkip,
        searchData,
        PresentFilterValues,
        isFirstTime,
        tags_selected,
        filterIncludedTags,
        dateValue,
        selectedOrders,
      });

      const currentTags = this.state.ordersTagsStatus?.tags;
      const newTags = ordersTagsStatus?.tags;
      const tagsMatch = currentTags && JSON.stringify(currentTags.all_present) === JSON.stringify(newTags.all_present) &&
                      JSON.stringify(currentTags.not_present) === JSON.stringify(newTags.not_present) &&
                      JSON.stringify(currentTags.partially_present) === JSON.stringify(newTags.partially_present);

      // console.log("Current ordersTagsStatus:", this.state.ordersTagsStatus);
      // console.log("New ordersTagsStatus:", ordersTagsStatus, isFirstTime);
      // debugger
      // if (isFirstTime) {
        let temp = ordersTagsStatus === "Job is still in progress" ? this.state.ordersTagsStatus : ordersTagsStatus
        this.setState({ordersTagsStatus: temp });
        isFirstTime = false
      // }
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  }

  updateOrdersTagsStatus = (status, tagName) => {
    this.setState(prevState => {
      // const { all_present, partially_present, not_present } = prevState?.ordersTagsStatus;
      if (status === 'all_present') {
        // isFirstTime = true;
        return {
          ordersTagsStatus: {
            ...prevState.ordersTagsStatus,
            tags: {
              ...prevState.ordersTagsStatus.tags,
              all_present: prevState.ordersTagsStatus.tags.all_present.filter(tag => tag !== tagName),
              not_present: [...prevState.ordersTagsStatus.tags.not_present, tagName]
            }
          }
        };
      } else if (status === 'partially_present') {
        // isFirstTime = true;
        return {
          ordersTagsStatus: {
            ...prevState.ordersTagsStatus,
            tags: {
              ...prevState.ordersTagsStatus.tags,
              partially_present: prevState.ordersTagsStatus.tags.partially_present.filter(tag => tag !== tagName),
              not_present: [...prevState.ordersTagsStatus.tags.not_present, tagName]
            }
          }
        };
      } else if (status === 'not_present') {
        // isFirstTime = true;
        return {
          ordersTagsStatus: {
            ...prevState.ordersTagsStatus,
            tags: {
                ...prevState.ordersTagsStatus.tags,
              all_present: [...prevState.ordersTagsStatus.tags.all_present, tagName],
              not_present: prevState.ordersTagsStatus.tags.not_present.filter(tag => tag !== tagName),
            }
          }
        };
      }

      // Return prevState if no conditions are matched
      return prevState;
    });
  };

  loadData = async (
    {skip, limit, filterValue, sortInfo},
    getStatus = 'all'
  ) => {
    const shouldSearchWithoutFilters =
      Boolean(this.state.searchData.search) && !this.state.searchFiltersApplied;
    const effectiveFilterValue = shouldSearchWithoutFilters ? [] : filterValue;
    const effectiveDateValue = shouldSearchWithoutFilters ? 'all_day' : dateValue;
    const effectiveDateRange = shouldSearchWithoutFilters
      ? {"start_date": '', "end_date": ''}
      : dateRangeValues;
    const effectiveStatus = shouldSearchWithoutFilters ? 'all' : getStatus;

    isValuePresentForAny = effectiveFilterValue.some(
      filter =>
        filter.hasOwnProperty('value') &&
        filter.value !== null &&
        filter.value !== '' &&
        !(Array.isArray(filter.value) && filter.value.length === 0) &&
        filter.name !== 'Status'
    );
    const originalFilterIncludedTags = filterIncludedTags;
    const originalFilterIncludedSkus = filterIncludedSkus;
    const {selectedUser, selectedTag, selectedSku, isTagIncluded, isSkuIncluded, updatedFilterValue} =
      processUserAndTagFilter(effectiveFilterValue, includedTags, originalFilterIncludedTags, includedSkus, originalFilterIncludedSkus);
    let finalFilterValue = [...updatedFilterValue];
    if (!shouldSearchWithoutFilters && this.state.selectedTags && this.state.selectedTags.length > 0) {
      const tagsFilterExists = finalFilterValue.find(item => item.name === 'Tags');
      if (!tagsFilterExists) {
        const tagsOperator = originalFilterIncludedTags ? 'eq' : 'neq';
        finalFilterValue.push({
          name: 'Tags',
          operator: tagsOperator,
          type: 'string',
          value: this.state.selectedTags
        });
      } else {
        const tagsFilterIndex = finalFilterValue.findIndex(item => item.name === 'Tags');
        if (tagsFilterIndex >= 0) {
          finalFilterValue[tagsFilterIndex] = {
            ...finalFilterValue[tagsFilterIndex],
            operator: originalFilterIncludedTags ? 'eq' : 'neq'
          };
        }
      }
    }
    if (!shouldSearchWithoutFilters && this.state.selectedSkus && this.state.selectedSkus.length > 0) {
      const skusFilterExists = finalFilterValue.find(item => item.name === 'Skus');
      if (!skusFilterExists) {
        const skusOperator = originalFilterIncludedSkus ? 'eq' : 'neq';
        finalFilterValue.push({
          name: 'Skus',
          operator: skusOperator,
          type: 'string',
          value: this.state.selectedSkus
        });
      } else {
        const skusFilterIndex = finalFilterValue.findIndex(item => item.name === 'Skus');
        if (skusFilterIndex >= 0) {
          finalFilterValue[skusFilterIndex] = {
            ...finalFilterValue[skusFilterIndex],
            operator: originalFilterIncludedSkus ? 'eq' : 'neq'
          };
        }
      }
    }
    isValuePresentForAny =
      effectiveDateValue !== 'all_day' ? true : isValuePresentForAny;
    const statusFilter = effectiveFilterValue.find(filter => filter.name === 'Status');
    const selectedStatusValues = Array.isArray(effectiveStatus)
      ? effectiveStatus.filter(Boolean)
      : (effectiveStatus && effectiveStatus !== 'all' ? [effectiveStatus] : []);
    const shouldForceAwaitingPayload =
      !shouldSearchWithoutFilters &&
      selectedStatusValues.length === 0 &&
      (
        isAllFiltersDisabled ||
        (
          effectiveDateValue === 'all_day' &&
          (!this.state.selectedStates || this.state.selectedStates.length === 0) &&
          (this.state.selectedTags?.length || 0) === 0 &&
          (this.state.selectedUsers?.length || 0) === 0 &&
          (this.state.selectedSkus?.length || 0) === 0 &&
          !isValuePresentForAny
        )
      );
    PresentFilterValues = JSON.stringify(effectiveFilterValue);

    let sortField = sortInfo?.columnName ? this.sortColumnNames[sortInfo?.columnName] : '';
    let sortOrder = sortInfo?.dir === -1 ? 'DESC' : 'ASC';

    if (!sortInfo?.columnName) {
      if (this.state.dateSortField === DATE_SORT_OPTIONS.UPDATED_IN_GP) {
        sortField = 'updated_at';
        sortOrder = 'DESC';
      } else {
        sortField = 'order_placed_time';
        sortOrder = 'ASC';
      }
    }

    // this.resetFilters(statusFilter.value);
    const userUrl = await AsyncStorage.getItem('url');
    const selectedUserValue = shouldSearchWithoutFilters || isAllFiltersDisabled
      ? []
      : (Array.isArray(this.state.selectedUsers) && this.state.selectedUsers.length > 0
          ? this.state.selectedUsers
          : selectedUser);
    const userFilterOperator = filterValue.find(f => f.name === 'User')?.operator;
    const filterIncludedUsers = !['notContains', 'neq', 'notEmpty'].includes(userFilterOperator);
    let usersForApiParam = selectedUserValue;
    if (userFilterOperator === 'empty' || userFilterOperator === 'notEmpty') {
      usersForApiParam = shouldSearchWithoutFilters || isAllFiltersDisabled ? [] : ['unassigned'];
    }
    const selectedTagValue = shouldSearchWithoutFilters || isAllFiltersDisabled
      ? []
      : (Array.isArray(this.state.selectedTags) && this.state.selectedTags.length > 0
          ? this.state.selectedTags
          : selectedTag);
    const selectedSkuValue = shouldSearchWithoutFilters || isAllFiltersDisabled ? [] : selectedSku;
    const rawSkusForApi =
      !shouldSearchWithoutFilters && (Array.isArray(this.state.selectedSkus) && this.state.selectedSkus.length > 0)
        ? this.state.selectedSkus
        : (Array.isArray(selectedSkuValue)
            ? selectedSkuValue
            : (selectedSkuValue ? [selectedSkuValue] : []));
    if (selectedStatusValues.length > 0) {
      const statusIndex = finalFilterValue.findIndex(item => item.name === 'Status');
      const statusValue = selectedStatusValues.length === 1
        ? selectedStatusValues[0]
        : selectedStatusValues;

      if (statusIndex >= 0) {
        finalFilterValue[statusIndex] = {
          ...finalFilterValue[statusIndex],
          value: statusValue
        };
      } else {
        finalFilterValue.push({
          name: 'Status',
          operator: 'eq',
          type: 'select',
          value: statusValue
        });
      }
    }
    if (shouldForceAwaitingPayload) {
      const statusIndex = finalFilterValue.findIndex(item => item.name === 'Status');
      if (statusIndex >= 0) {
        finalFilterValue[statusIndex] = {
          ...finalFilterValue[statusIndex],
          value: 'Awaiting'
        };
      }
    }

    const queryContract = buildOrderGridQueryContract({
      dateValue: effectiveDateValue,
      dateRange: effectiveDateRange,
      filterValue: finalFilterValue,
      rawFilterValue: effectiveFilterValue,
      matchOption: this.state.matchOption,
      search: this.state.searchData.search,
      selectedStates: effectiveStatus,
      selectedTags: selectedTagValue,
      selectedSkus: rawSkusForApi,
      selectedUsers: selectedUserValue,
      filterIncludedTags: originalFilterIncludedTags,
      filterIncludedSkus: originalFilterIncludedSkus,
      sortField,
      sortOrder,
      skip,
      limit
    });
    const queryParams = buildLegacyOrderGridSearchParams({
      filter: effectiveStatus,
      sortOrder,
      limit,
      sortField,
      skip,
      dateValue: effectiveDateValue,
      dateRange: effectiveDateRange,
      filterValue: finalFilterValue,
      matchOption: this.state.matchOption,
      search: this.state.searchData.search,
      filterIncludedTags: originalFilterIncludedTags,
      selectedTags: selectedTagValue,
      selectedUsers: usersForApiParam,
      filterIncludedSkus: originalFilterIncludedSkus,
      selectedSkus: rawSkusForApi,
      queryContract
    });
    const url = `${userUrl}/orders/sorted_and_filtered_data.json?${queryParams}&filterIncludedUsers=${filterIncludedUsers}`;
    const access_token = await AsyncStorage.getItem('access_token');
    const updatedData = await axios({
      method: 'get',
      url: url,
      headers: {Authorization: `Bearer ${access_token}`}
    });
    if (isFirstCall) {previousData = updatedData }
    isFirstCall = false;
    prevSkip = skip;
    prevlimit = limit;
    includedTags = updatedData?.data.tags?.present || [];
    excludedTags = updatedData?.data.tags?.not_present || [];
    includedSkus = normalizeSkuList(updatedData?.data.sku_orders_count ?? updatedData?.data.skus?.present, 'present');
    excludedSkus = normalizeSkuList(updatedData?.data.skus?.not_present, 'not_present');
    // debugger
    usersOrderCount = updatedData?.data.users;
    usersOrderAssignedCount = updatedData?.data.assigned_users;
    const responseData = updatedData?.data || {};
    const queryCounts = getServerQueryCounts(responseData);
    const activeFilterCount = getOrderGridActiveFilterCount({
      selectedStates: selectedStatusValues,
      selectedTags: selectedTagValue,
      selectedUsers: selectedUserValue,
      selectedSkus: rawSkusForApi,
      selectedDateMode: effectiveDateValue
    });
    const searchExpansionPrompt = shouldSearchWithoutFilters
      ? {visible: false, hiddenCount: 0}
      : getSearchExpansionPromptState(
        responseData?.search_metadata,
        {
          search: this.state.searchData.search,
          activeFilterCount,
          unfilteredCount: responseData?.orders_count?.all,
          filteredCount:
            queryCounts?.filtered_count ??
            queryCounts?.all ??
            responseData?.orders?.length
        }
    );
    displayPrompt = searchExpansionPrompt.visible;
    const nextSelectedSkus = (this.state.selectedSkus?.length > 0 && !selectedSkuValue?.length)
      ? this.state.selectedSkus
      : selectedSkuValue;
    this.setState({
      selectedTags: selectedTagValue,
      selectedSkus: nextSelectedSkus,
      searchExpansionPrompt
    });
    isAllFiltersDisabled = false;
    return {
      ...updatedData?.data,
      query_counts: queryCounts,
      searchExpansionPrompt
    };
  };

  updateLiveStatusCounts = orders_count => {
    if (!orders_count || this.state.searchData?.search) {
      return;
    }
    this.setState({liveOrderCount: orders_count});
  };

  updateInViewCounts = returned_orders_count => {
    this.setState({inViewCount: returned_orders_count || null});
  };

  loadScannedTodayData = async ({skip, limit, sortInfo}) => {
    const userUrl = await AsyncStorage.getItem('url');
    const access_token = await AsyncStorage.getItem('access_token');
    const sortOrder = sortInfo?.dir === -1 ? 'DESC' : 'ASC';

    const url = `${userUrl}/orders/get_scanned_today_orders.json?order=${sortOrder}&limit=${limit}&sort=${
      sortInfo?.columnName ? this.sortColumnNames[sortInfo?.columnName] : ''
    }&offset=${skip}&app=${true}`;

    const updatedData = await axios({ method: 'get', url: url, headers: {Authorization: `Bearer ${access_token}`} });

    if (isFirstCall) {
      previousData = updatedData;
    }
    isFirstCall = false;
    prevSkip = skip;
    prevlimit = limit;

    includedTags = updatedData?.data.tags?.present || [];
    excludedTags = updatedData?.data.tags?.not_present || [];
    includedSkus = normalizeSkuList(updatedData?.data.sku_orders_count ?? updatedData?.data.skus?.present, 'present');
    excludedSkus = normalizeSkuList(updatedData?.data.skus?.not_present, 'not_present');
    usersOrderCount = updatedData?.data.users || {};
    usersOrderAssignedCount = updatedData?.data.assigned_users || {};

    return {
      ...updatedData?.data,
      query_counts: getServerQueryCounts(updatedData?.data)
    };
  };

  loadScannedTodayOrders = async e => {
    const response = await this.loadScannedTodayData(e);

    const {orders, orders_count, returned_orders_count, query_counts} = response;

    this.updateLiveStatusCounts(orders_count);
    this.updateInViewCounts(returned_orders_count);
    allOrders = orders;
    const formattedItems = this.formatItems(orders);

    this.setState({
      formattedItems: formattedItems,
      current_orders_count: query_counts || orders_count,
    });
    const count = (query_counts || orders_count)?.scannedtoday;
    this.setState({currentOrdersCount: count});
    const result = {data: formattedItems, count: count};
    return result;
  };

  loadOrders = async (e) => {
    if (islastSearchPresent === true){
      let presentData = this.loadSearchData();
      islastSearchPresent = false;
      return presentData;
    }
    const {orders, orders_count, returned_orders_count, query_counts} = await this.loadData(e);
    this.updateLiveStatusCounts(orders_count);
    this.updateInViewCounts(returned_orders_count);
    allOrders = orders;
    const formattedItems = this.formatItems(orders);
    this.setState({
      formattedItems: formattedItems,
      current_orders_count: query_counts || orders_count,
    });
    if(this.state.searchData.search && orders_count && orders_count.all === 0)
    {
      this.alertBox(i18n.t('order.orderNotFound'));
      return {data: "", count: 0}
    }
    const count =
      (query_counts || orders_count)?.filtered_count >= 0
        ? (query_counts || orders_count)?.filtered_count
        : (query_counts || orders_count)?.all;
    this.setState({currentOrdersCount: count});
    // this.setState({ currentOrdersCount: orders_count?.filtered_count});
    return {data: formattedItems, count: count};
  }

  clearFiltersAndExpandSearch = () => {
    displayPrompt = false;
    update = false;
    isAllFiltersDisabled = true;
    filterIncludedTags = true;
    filterIncludedSkus = true;
    PresentFilterValues = undefined;
    isSearchOrder = false;
    currentSelectedDate = 'all_day';
    dateValue = '';
    dateRangeValues['start_date'] = '';
    dateRangeValues['end_date'] = '';
    this.setState({
      current_orders_count: this.props.orderCount,
    });
    const gridRef = this.state.gridRef?.current;
    if (gridRef) {
      gridRef.clearAllFilters();
      this.setState(
        {
          searchProduct: [],
          clearAllFilters: true,
          selectedStates: [],
          selectedTags: [],
          selectedSkus: [],
          selectedUsers: [],
          addedSkus: [],
        isScannedTodayView: false,
          matchOption: 'Any',
          searchExpansionPrompt: {
            visible: false,
            hiddenCount: 0
          }
        },
        () => {
          this.refreshOrdersGrid('search-expand-clear-filters', {
            resetSelection: false,
            delay: 0
          });
        }
      );
    }
  };

  loadOrderWithStatus = async e => {
    if (this.state.usingPreFilteredData && this.preFilteredResult) {
      const result = this.preFilteredResult;
      this.setState({ usingPreFilteredData: false });
      this.preFilteredResult = null;
      return result;
    }

    const selectedState = this.state.selectedStates;
    const {orders, orders_count, returned_orders_count, query_counts, tags, searchExpansionPrompt} = await this.loadData(e, selectedState);
    this.updateLiveStatusCounts(orders_count);
    this.updateInViewCounts(returned_orders_count);
    const formattedItems = this.formatItems(orders) || [];
    allOrders =  orders;
    allOrdersWithStatus =  formattedItems;
    this.setState({
      formattedItems: formattedItems,
      current_orders_count: query_counts || orders_count,
    });
    const counts = query_counts || orders_count;
    const count =
      counts?.filtered_count >= 0
        ? counts?.filtered_count === 0
          ? 0
          : counts?.filtered_count || counts?.all
        : this.sumSelectedStates(counts, selectedState);
    this.setState({currentOrdersCount: count});
    if (this.state.searchData.search && !this.state.clearAllFilters) {
      displayPrompt = searchExpansionPrompt.visible;
      this.setState({searchExpansionPrompt});
    }
    return {data: formattedItems, count: count || 0};
  }

  loadSearchData = async (e) =>{
    isSearchOrder = false
    islastSearchPresent = true;
    let formattedItems = this.formatItems(this.props.searchProduct);
    let filteredOrders = [];
    this.state.selectedStates.forEach(selectedStatus => {
      const ordersForStatus = formattedItems.filter(order => order.Status.toLowerCase() === selectedStatus.toLowerCase());

      filteredOrders = filteredOrders.concat(ordersForStatus);
    });
    formattedItems = filteredOrders.length > 0 ? filteredOrders : formattedItems;
    this.setState({
      formattedItems: formattedItems,
    })
    let count = this.state.selectedStates[0] === undefined ?
      this.state.searchOrderCount.search : this.props.searchOrderCount[this.state.selectedStates[0]]
    return {data: formattedItems, count: count};
  }

  sumSelectedStates(orderCount, selectedStates, forSelectedOrders = false) {
      let sum = 0;
      selectedStates =  Array.isArray(selectedStates) ? selectedStates : [selectedStates];
      if (!orderCount) {return;}
      if (!Array.isArray(selectedStates)) {
        selectedStates = [selectedStates];
      }
      selectedStates.forEach(state => {
        state = state === "PartiallyScanned" ? "partially_scanned" : state
        state = state === "ServiceIssue" ? "serviceissue" : state

        sum += orderCount[state?.toLowerCase()] || 0;
      });
      sum = forSelectedOrders ? (!isValuePresentForAny && sum || orderCount?.filtered_count || orderCount?.all || 0) : (isValuePresentForAny && this.state.currentOrdersCount === 0 ? 0 : this.state.currentOrdersCount || sum || 0)
      return sum.toString();
  }

  isEmptyObject = (obj) => {
    if(obj?.constructor === Object){
      return  Object.keys(obj).length > 0 ? true : false ;
    }
    return true;
  };

  dataSourceWrapper = async (e) => {
    FirstOrdersTagsStatus = true;

    try {
      if (this.state.isScannedTodayView) {
        return await this.loadScannedTodayOrders(e);
      }

      if (this.state.selectedStates?.length > 0 && !isSearchOrder) {
        return await this.loadOrderWithStatus(e);
      } else {
        if (isSearchOrder) {
          return await this.loadSearchData(e);
        } else {
          return await this.loadOrders(e);
        }
      }
    } catch (error) {
      console.error('Failed to load orders:', error);
      return { data: [], count: 0 };
    }
  };

  checCallBack = () => {
    return this.dataSourceWrapper;
  };

  filterOrders = () => {
    this.refreshOrdersGrid('filter-orders', {
      resetSelection: false,
      delay: 1000
    });
  };

  resetOrderFilters = statues => {
    update = false;
    statues = statues.length === 0 ? null : statues;
    this.state.gridRef?.current.setColumnFilterValue('Status', statues);
    const list =
      statues?.length > 0
        ? this.getFilteredOrders(statues)
        : this.formatItems(this.props.productSearchList);
    this.setState({
      formattedItems: list,
      selectedStates: statues
    });
  };
  handleSkipChange = (skip) => {
    let pageNumber = Math.floor(skip / 20) + 1;
    let currentSelectedRows = this.state.selectedRows[pageNumber] || {};
    if (this.state.allOrdersSelected) {
      // Paging within the same filtered view keeps the whole-view selection.
      // handleSelectionChange preserves the flag for a whole-page select, so
      // there is nothing to re-set here afterwards.
      this.setState(
        {
          currentPage: pageNumber
        },
        () => {
          this.selectAllAfterSkipTimer = setTimeout(() => {
            this.state.gridRef?.current?.selectAll?.();
          }, 3000);
        }
      );
      return;
    }
    this.setState({
      currentPage: pageNumber,
      gridSelectionRef: {
        ...this.state.gridSelectionRef,
        selected: getTransformedList(currentSelectedRows)
      }
    });
  }
  handleSelectionChange = (e) => {
    const {currentPage, selectedRows} = this.state;
    let selected = getUpdatedSelectedList(e, this.state.isShiftPressed, selectedRows[currentPage]);
    const unSelectedItems = Object.keys(e.unselected || {}).length;
    // The grid reports a whole-page select as `selected === true` with nothing
    // unselected. That is what selectAll() produces, so it must not cancel an
    // in-flight "select every order in the view" - the grid delivers this event
    // synchronously in most browsers but on Safari 35ms later, which is exactly
    // how the flag used to be wiped straight after the user set it.
    const isWholePageSelection = e.selected === true && unSelectedItems === 0;
    const updatedSelectedRows = {...selectedRows};
    if (Object.keys(selected).length === 0) {
      delete updatedSelectedRows[currentPage];
    } else {
      updatedSelectedRows[currentPage] = selected;
    }
    this.setState(prev => {
      const keepAllOrdersSelected =
        prev.allOrdersSelected && isWholePageSelection;
      const gridSelectionRef = {...e};
      if (
        !keepAllOrdersSelected &&
        (prev.allOrdersSelected || unSelectedItems > 0)
      ) {
        gridSelectionRef.selected = getTransformedList(selected);
        gridSelectionRef.unselected = null;
      }
      if (prev.isShiftPressed) {
        gridSelectionRef.selected = selected;
      }
      return {
        gridSelectionRef,
        selectedRows: updatedSelectedRows,
        currentPage: currentPage,
        allOrdersSelected: keepAllOrdersSelected
      };
    });
  }
  handleResetFilter = () => {
    this.setState({
      gridSelectionRef: {
        ...this.state.gridSelectionRef,
        selected: {}
      },
      selectedRows: {},
      allOrdersSelected: false
    });
  };
  getCountOfOrdersInView = () => {
    const counts = this.state.current_orders_count || this.props.orderCount || {};

    if (counts.filtered_count >= 0) {
      return counts.filtered_count;
    }

    if (counts.all >= 0) {
      return counts.all;
    }

    return allOrders?.length || this.state.formattedItems?.length || 0;
  };

  handleDisableFilters = ()=> {
    update = false;
    isAllFiltersDisabled = true;
    filterIncludedTags = true;
    filterIncludedSkus = true;
    PresentFilterValues = undefined;
    isSearchOrder = false;
    currentSelectedDate = "all_day"
    dateValue = ""
    dateRangeValues["start_date"] = ""
    dateRangeValues["end_date"] = ""
    this.state.gridRef?.current.clearAllFilters();
    const formattedItems = this.formatItems(this.props.productSearchList);
    this.setState(
      {
        formattedItems: formattedItems,
        searchProduct: [],
        clearAllFilters: true,
        selectedStates: [],
        selectedUsers: [],
        selectedTags: [],
        selectedSkus: [],
        addedSkus: [],
        isScannedTodayView: false,
        matchOption: 'Any'
      },
      () => {
        this.refreshOrdersGrid('disable-filters', {
          delay: 500
        });
      }
    );
  };
  handleTagSelectionChange = (tagName, statues) => {
    this.refreshOrdersGrid('filter-change', {reload: false});
    this.state.gridRef?.current.setColumnFilterValue(tagName, statues);
  };

  handlePriorityToggle = id => {
    priorityListDisplayToggle(id, this.state, newState => this.setState(newState));
  };

  renderSearchBar = () => {
    return (
      <View style={{alignSelf: 'stretch'}}>
        <SearchBar
          searchData={this.state?.searchData?.search}
          handleChange={text => {
            this.handleChange(text);
            this.setState({searchTxt: text});
          }}
          searchItem={e => this.searchItem(e)}
          searchField={this.searchField}
          windowWidth={this.state.windowWidth}
          onKeyPress={e => {
            shouldUpdateCount = false;
            this.searchItem();
          }}
          handleClearSearch={() => {
            this.clearSearch();
          }}
        />
        {this.shouldShowApplySearchFiltersButton() && (
          <TouchableOpacity
            testID="applyCurrentFiltersToSearch"
            onPress={this.applyCurrentFiltersToSearch}
            {...(Platform.OS === 'web' ? {onClick: this.applyCurrentFiltersToSearch} : {})}
            style={{
              alignSelf: 'flex-start',
              borderColor: '#9bb0c6',
              borderRadius: 6,
              borderWidth: 1,
              marginLeft: 45,
              marginTop: 8,
              paddingHorizontal: 10,
              paddingVertical: 5
            }}>
            <Text
              style={{
                color: '#c7d5e3',
                fontFamily: 'Poppins_400Regular',
                fontSize: 13
              }}>
              Apply Current Filters
            </Text>
          </TouchableOpacity>
        )}
      </View>
    );
  };

  renderFilterDisableButton = () => {
    const filterCount = getOrderGridActiveFilterCount({
      selectedStates: this.state.selectedStates,
      selectedTags: this.state.selectedTags,
      selectedUsers: this.state.selectedUsers,
      selectedSkus: this.state.selectedSkus,
      selectedDateMode: currentSelectedDate
    });

    const isActive = filterCount > 0;

    return (
      <DisableFiltersButton
        isFiltersActive={isActive}
        onPress={this.handleDisableFilters}
        filterCount={filterCount}
      />
    );
  };

  handleClearAllAssignment = () => {
    this.setState({showPrompt: false});
    const active_usernames = usersOrderCount
    ?.filter(user => parseInt(user.unique_order_count) > 0)
    ?.map(user => user.username);
    this.assignOrdersToUsers(active_usernames, false, 0, true)
  }

  render() {
    this.getUnselectedItemsFormattedIds();
    const allOrdersSelected = this.state.allOrdersSelected;
    let selectedLength = getSelectedOrders(this.state.selectedRows)?.length;
    // selectedLength = this.state?.gridSelectionRef?.selected === true ? this.sumSelectedStates(this.state.current_orders_count, this.state.selectedStates, true) : selectedLength;
    // selectedLength = this.state?.gridSelectionRef?.unselected ? selectedLength - Object.keys(this.state?.gridSelectionRef?.unselected || {}).length : selectedLength;
    const isSelectionAvailable =
      this.state.selectedRows === true ||
      allOrdersSelected ||
      Object.keys(this.state.selectedRows || {}).length > 0;
    return (
      <LinearGradient
        colors={[
          '#000',
          '#000',
          '#5c778f',
          '#5c778f',
          '#253c57',
          '#253c57',
          '#000'
        ]}
        start={[-0.5, -1]}
        style={{
          height: '100%',
          paddingBottom: 15,
          width: '100%'
        }}>
        <View style={CommonStyles.orderSearchListContainer}>
          {this.state.showPrompt && (
            <Prompt
              msg={i18n.t("order.clearAllAssignmentMessage")}
              onPressOk={this.handleClearAllAssignment}
              onPressCancel={() => this.setState({showPrompt: false})}
            />
          )}
          <View
            style={CommonStyles.orderSearchListSubContainer}>
            <View
              style={[
                CommonStyles.rdgHeader,
                {display: !isSelectionAvailable && 'none'}
              ]}>
              {isSelectionAvailable && (
                <UpdateTagsDropDowns
                  ordersTags={this.props?.ordersTags}
                  loadTagsData={() => {
                    this.loadTagsData();
                  }}
                  ordersTagsStatus={this.state.ordersTagsStatus}
                  getStatus={getStatus(this.state.selectedStates)}
                  prevlimit={prevlimit}
                  prevSkip={prevSkip}
                  filters={PresentFilterValues || '[]'}
                  search={this.state.searchData.search || ''}
                  sidebarFilters={{
                    username: (this.state.selectedUsers || []).join(','),
                    tags_name: (this.state.selectedTags || []).join(','),
                    skus_name: this.state.selectedSkus || [],
                    filterIncludedSkus: filterIncludedSkus,
                    match_option: this.state.matchOption,
                    dateValue: dateValue,
                    dateRange: JSON.stringify(dateRangeValues)
                  }}
                  gridSelectionRef={this.state.gridSelectionRef}
                  selectedStates={this.state.selectedStates}
                  FirstOrdersTagsStatus={FirstOrdersTagsStatus}
                  ResetFirstOrdersTagsStatus={() => {
                    FirstOrdersTagsStatus = false;
                  }}
                  updateOrdersTagsStatus={(status, tagName) => {
                    this.updateOrdersTagsStatus(status, tagName);
                    this.props.GetTagPriorityList();
                  }}
                  unselectedOrderItems={unselectedOrderItems}
                  GetTags={() => {
                    this.props.GetAllTags();
                  }}
                  filterIncludedTags={filterIncludedTags}
                  resetSelectedTags={() => {
                    this.setState({
                      selectedTags: []
                    });
                    this.handleResetFilter();
                  }}
                  selectedRows={this.state.selectedRows}
                />
              )}
              <OrderUserTagsDropdown
                userTags={usersOrderCount}
                clearAllFilters={this.state.clearAllFilters}
                resetFilterCheck={() => {
                  this.setState({
                    clearAllFilters: false
                  });
                }}
                status={this.state.selectedTags || []}
                setSelectedTags={statues => {
                  // this.setState({
                  //   selectedTags: statues
                  // });
                }}
                setPrompt={(value)=>{
                  this.setState({
                    showPrompt: value
                  });
                }}
                setFilterUserTags={value => {
                  filterIncludedTags = value;
                }}
                assignOrdersToUsers={(value, shoudlAssign) =>
                  this.assignOrdersToUsers(value, shoudlAssign, selectedLength)
                }
                userAddedCount={userAddedCount}
              />
            </View>
            <View
              ref={this.gridPanelRef}
              onLayout={this.measureGridPanel}
              style={[
                CommonStyles.orderInfoStyle,
                {
                  zIndex: -1,
                  fontFamily: 'Poppins_300Light',
                  padding: '13px',
                  // Measured height wins; the estimate below only covers the first
                  // frame (and any environment without getBoundingClientRect).
                  height:
                    this.state.gridPanelHeight ??
                    Dimensions.get('window').height - 100,
                  backgroundColor: 'rgb(49, 57, 67)',
                  flexDirection: 'row',
                  paddingLeft: 1,
                  borderTopRightRadius: isSelectionAvailable && 0
                }
              ]}>
              <View>
                <PriorityListToggle
                  count={
                    allOrdersSelected
                      ? this.getCountOfOrdersInView()
                      : selectedLength
                  }
                  onPress={id => this.handlePriorityToggle(id)}
                  isListDisplayed={true}
                  selectedMenuId={this.state.selectedMenuId}
                />
                <CustomScrollBar showDefaultStyles={false}>
                  {!this.state.displayPriorityList && (
                    <View style={[{width: 280, flexDirection: 'column'}]}>
                      <View style={{height: '100%', width: '102%'}}>
                        <Text
                          style={CommonStyles.ordersInCurrentView}>
                          Orders in current View:{' '}
                          {this.getCountOfOrdersInView()}
                        </Text>
                        {this.renderSearchBar()}
                        <View
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            width: '95%'
                          }}>
                          <SelectAllButton
                            selectedOrders={
                              allOrdersSelected
                                ? this.getCountOfOrdersInView()
                                : selectedLength
                            }
                            onPress={() => {
                              if (selectedLength > 0 || allOrdersSelected) {
                                this.handleResetFilter();
                                return;
                              }
                              // Record the intent before asking the grid to
                              // select, so the resulting selection-change event
                              // cannot arrive first and cancel it.
                              this.setState({allOrdersSelected: true}, () => {
                                this.state.gridRef?.current?.selectAll?.();
                              });
                            }}
                          />
                          {this.renderFilterDisableButton()}
                        </View>
                        <View style={{alignSelf: 'stretch'}}>
                          <SavedFavouriteViewsDropdown
                            getCurrentFiltersSnapshot={this.getCurrentFiltersSnapshot}
                            onApplySavedFilter={this.applySavedFiltersSnapshot}
                          />
                          <OrderStatusDropdown
                            getFilteredOrders={status => {
                              this.getFilteredOrders(status, true);
                            }}
                            getScannedTodayOrders={() => {
                              this.getScannedTodayOrders();
                            }}
                            resetFilters={statues => {
                              update = false;
                              statues = statues.length === 0 ? null : statues;
                              const isScannedTodaySelected = statues?.includes('ScannedToday');
                              const gridStatusFilterValue = Array.isArray(statues) && statues.length === 1
                                ? statues[0]
                                : statues;

                              this.setState(
                                {
                                  selectedStates: statues,
                                  isScannedTodayView: isScannedTodaySelected
                                },
                                () => {
                                  this.state.gridRef?.current?.setColumnFilterValue?.(
                                    'Status',
                                    gridStatusFilterValue
                                  );
                                  this.refreshOrdersGrid('status-filter-reset', {
                                    reload: false
                                  });
                                }
                              );
                            }}
                            clearAllFilters={this.state.clearAllFilters}
                            resetFilterCheck={() => {
                              this.setState({
                                clearAllFilters: false
                              });
                            }}
                            status={this.state.selectedStates || []}
                            isShiftPressed={this.state.isShiftPressed}
                            orderCount={this.state.liveOrderCount || this.props.orderCount || {}}
                            inViewCount={this.state.inViewCount}
                          />
                        </View>
                        <View style={{alignSelf: 'stretch'}}>
                          <OrderTagsDropdown
                            includedTags={includedTags}
                            excludedTags={excludedTags}
                            clearAllFilters={this.state.clearAllFilters}
                            resetFilterCheck={() => {
                              this.setState({
                                clearAllFilters: false
                              });
                            }}
                            status={this.state.selectedTags || []}
                            setSelectedTags={statues => {
                              this.setState({ selectedTags: statues }, () => {
                                this.handleTagSelectionChange('Tags', statues);
                              });
                            }}
                            setFilterIncludedTags={value => {
                              filterIncludedTags = value;
                            }}
                            filterIncludedTags={filterIncludedTags}
                            matchOptionFlag={this.state.matchOption}
                            setMatchOptionFlag={value => {
                              this.setState({
                                matchOption: value
                              });
                              this.refreshOrdersGrid('tag-match-option-change', {
                                resetSelection: false
                              });
                            }}
                          />
                          <UserTagsDropdown
                            assignedUserTags={usersOrderAssignedCount || []}
                            clearAllFilters={this.state.clearAllFilters}
                            resetFilterCheck={() => {
                              this.setState({
                                clearAllFilters: false
                              });
                            }}
                            status={this.state.selectedUsers}
                            setSelectedUsers={statues => {
                              this.setState({ selectedUsers: statues }, () => {
                                this.handleTagSelectionChange('User', statues);
                              });
                            }}
                          />
                          <OrderSkusDropdown
                            includedSkus={includedSkus}
                            excludedSkus={excludedSkus}
                            addedSkus={this.state.addedSkus || []}
                            clearAllFilters={this.state.clearAllFilters}
                            resetFilterCheck={() => {
                              this.setState({
                                clearAllFilters: false
                              });
                            }}
                            status={this.state.selectedSkus || []}
                            setSelectedSkus={statues => {
                              this.setState({ selectedSkus: statues });
                              this.handleTagSelectionChange('Skus', statues);
                            }}
                            setFilterIncludedSkus={value => {
                              filterIncludedSkus = value;
                            }}
                            filterIncludedSkus={filterIncludedSkus}
                            matchOptionFlag={this.state.matchOption}
                            setMatchOptionFlag={value => {
                              this.setState({
                                matchOption: value
                              });
                              this.refreshOrdersGrid('sku-match-option-change', {
                                resetSelection: false
                              });
                            }}
                            onAddSku={(sku) => {
                              const { selectedSkus = [], addedSkus = [] } = this.state;
                              if (addedSkus.includes(sku)) return;
                              const newAddedSkus = [...addedSkus, sku];
                              const newSelectedSkus = selectedSkus.includes(sku)
                                ? selectedSkus
                                : [...selectedSkus, sku];
                              filterIncludedSkus = true;
                              this.setState({
                                addedSkus: newAddedSkus,
                                selectedSkus: newSelectedSkus
                              });
                              this.handleTagSelectionChange('Skus', newSelectedSkus);
                            }}
                            onRemoveSku={(sku) => {
                              const { selectedSkus = [], addedSkus = [] } = this.state;
                              const newAddedSkus = addedSkus.filter(s => s !== sku);
                              const newSelectedSkus = selectedSkus.filter(s => s !== sku);
                              this.setState({
                                addedSkus: newAddedSkus,
                                selectedSkus: newSelectedSkus
                              });
                              this.handleTagSelectionChange('Skus', newSelectedSkus);
                            }}
                            fetchSuggestions={getSkuSuggestions}
                          />
                          <View style={{alignSelf: 'stretch'}}>
                            <OrderDateDropdown
                              getFilteredOrders={(value, date = '') => {
                                if (date && value[0] === 'start_date') {
                                  date = moment(date).format('MM-DD-YYYY');
                                  dateRangeValues['start_date'] = date || '';
                                } else if (date && value[0] === 'end_date') {
                                  date = moment(date).format('MM-DD-YYYY');
                                  dateRangeValues['end_date'] = date || '';
                                  dateValue = '';
                                } else {
                                  if (
                                    value &&
                                    value[0] !== 'start_date' &&
                                    value[0] !== 'end_date'
                                  ) {
                                    dateValue = value[0] === 'all_day' ? '' : ((value && value[0]) || '');
                                    dateRangeValues['start_date'] = '';
                                    dateRangeValues['end_date'] = '';
                                  }
                                }
                                currentSelectedDate = (value && value[0]) || '';
                                this.refreshOrdersGrid('date-filter-change', {
                                  delay: 1000
                                });
                              }}
                              clearAllFilters={this.state.clearAllFilters}
                              resetFilterCheck={() => {
                                this.setState({
                                  clearAllFilters: false
                                });
                              }}
                              status={[currentSelectedDate]}
                              dateSortField={this.state.dateSortField}
                              onDateSortChange={this.handleDateSortChange}
                              orderCount={
                                this.state.searchData.search ||
                                this.state?.gridSelectionRef?.selected
                                  ? this.state.current_orders_count
                                  : this.props.orderCount
                              }
                            />
                          </View>
                        </View>
                      </View>
                    </View>
                  )}
                </CustomScrollBar>
                {this.state.displayPriorityList && (
                  <View style={{height: '100%'}}>
                    <OrderTagPriorityContainer
                      selectedMenuId={this.state.selectedMenuId}
                    />
                  </View>
                )}
              </View>
              <View
                style={{
                  display: 'flex',
                  flex: 1,
                  minWidth: 0
                }}>
                <View
                  style={[
                    CommonStyles.dataGirdHeaderContainer,
                    {width: '95%'}
                  ]}>
                  <Text
                    style={CommonStyles.dataGirdHeaderLabel}>
                    {this.state.selectedRows === true ||
                    Object.keys(this.state.selectedRows || {}).length
                      ? 'Modify selected:'
                      : 'Select orders to modify them'}
                  </Text>
                  {this.state.selectedRows === true ||
                  allOrdersSelected ||
                  Object.keys(this.state.selectedRows || {}).length > 0 ? (
                    <UpdateOrdersDropDowns
                      updateOrderStatus={this.updateOrderStatus}
                      gridSelectionRef={this.state.gridSelectionRef}
                      skip={prevSkip}
                      limit={prevlimit}
                      statuses={this.state.selectedStates}
                      redirectToProductDetail={item =>
                        this.redirectToProductDetail(item, true)
                      }
                      alertBox={(message, isInfo) => {
                        this.alertBox(message, isInfo);
                      }}
                      getOrderList={data => this.reloadGridOrders(data)}
                      searchString={this.state.searchData?.search || ''}
                      PresentFilterValues={PresentFilterValues}
                      resetSelectedOrders={this.handleResetFilter}
                      getUnselectedItems={() => {
                        this.getUnselectedItemsFormattedIds();
                      }}
                      unselectedOrderItems={unselectedOrderItems}
                      filterIncludedTags={filterIncludedTags}
                      selectedRows={this.state.selectedRows}
                      allOrdersSelected={allOrdersSelected}
                      dateValue={dateValue}
                      dateRange={dateRangeValues}
                      selectedUsers={this.state.selectedUsers || []}
                      selectedTags={this.state.selectedTags || []}
                      selectedSkus={this.state.selectedSkus || []}
                      matchOption={this.state.matchOption}
                      filterIncludedSkus={filterIncludedSkus}
                    />
                  ) : (
                    <></>
                  )}
                  <TouchableOpacity
                    testID="createOrderButton"
                    style={{
                      marginLeft: 'auto',
                      flexDirection: 'row',
                      justifyContent: 'center',
                      alignItems: 'center',
                      borderWidth: 1,
                      borderStyle: 'solid',
                      borderColor: '#fff',
                      borderRadius: 30,
                      height: 22
                    }}
                    onPress={() => this.props.CreateOrder()}>
                    <Text
                      style={[CommonStyles.saveButtonText, {fontSize: 12}]}>
                      {i18n.t('order.createOrder')}
                    </Text>
                  </TouchableOpacity>
                </View>
                <ReactDataGrid
                  key={`order-search-grid-${this.state.gridResetVersion || 0}`}
                  idProperty="id"
                  columns={this.getColumnsWithPreferences()}
                  dataSource={this.checCallBack()}
                  sortInfo={this.state.gridSortInfo}
                  onSortInfoChange={gridSortInfo => this.setState({gridSortInfo})}
                  style={this.gridStyle}
                  theme={'default-dark'}
                  onReady={e => {
                    this.setState({
                      gridRef: e
                    });
                  }}
                  onSelectionChange={this.handleSelectionChange}
                  onFilterValueChange={this.handleGridFilterValueChange}
                  onColumnVisibleChange={this.handleColumnVisibleChange}
                  onColumnOrderChange={this.handleColumnOrderChange}
                  onColumnResize={this.handleColumnResize}
                  reorderColumns={true}
                  enableColumnAutosize={true}
                  renderColumnContextMenu={this.renderColumnContextMenu}
                  // The column menu (and its Columns submenu) is absolutely positioned
                  // inside the grid by default, so it gets clipped at the top and the
                  // bottom by the page's scroll container. Portalling it to the body
                  // lets the grid's own viewport constraint actually apply, which is
                  // what makes every column reachable without scrolling.
                  menuPortalContainer={
                    typeof document !== 'undefined' ? document.body : undefined
                  }
                  showZebraRows={false}
                  pagination
                  defaultFilterValue={this.filterValue}
                  className="global-datagrid-3px-tomato-border"
                  checkboxColumn={true}
                  checkboxOnlyRowSelect={true}
                  defaultLimit={20}
                  onRowClick={this.handleRowClick}
                  onSkipChange={skip => {
                    this.handleSkipChange(skip);
                  }}
                  selected={this.state.gridSelectionRef?.selected}
                />
                {(this.state.searchExpansionPrompt?.visible || displayPrompt) && (
                  <SearchNotFoundPrompt
                    hiddenCount={this.state.searchExpansionPrompt?.hiddenCount}
                    clearFiltersAndExpandSearch={() => {
                      this.clearFiltersAndExpandSearch();
                    }}
                  />
                )}
              </View>
              {this.state.cartRemovalPrompt && (
                <CartRemovalConfirmModal
                  visible
                  message={this.state.cartRemovalPrompt.message}
                  onConfirm={this.confirmCartRemoval}
                  onCancel={this.cancelCartRemoval}
                />
              )}
              <StatusChangeOutcomeModal
                outcome={this.state.statusChangeOutcome}
                onTotesAcknowledged={this.acknowledgeTotes}
                onNotChangedAcknowledged={this.acknowledgeNotChanged}
              />
            </View>
          </View>
        </View>
        {this.state.popUpModelShow && alertMessage && (
          <PopUpModel
            closeAlert={this.closeAlert.bind(this)}
            message={alertMessage}
            messageTypeInfo={alertMessageIsInfo}
            contained
          />
        )}
      </LinearGradient>
    );
  }
}

const mapStateToProps = state => {
  return {
    searchProduct: state.order.searchResult,
    searchOrderCount: state.order.searchResultCount,
    ordersUpdated: state.order.ordersUpdated,
    ordersTags: state.order.ordersTags,
    users: state.user.users,
    bothSettings: state.user.bothSettings,
    settings: state.user.settings,
    users: state.user.users,
    userInfo: state.user.userInfo
  };
};

const mapDispatchToProps = {
  SearchOrder,
  GetOrderList,
  ResetSearchOrder,
  UpdateOrderStatus,
  CartedOrdersPreview,
  ResetOrdersUpdated,
  GetAllTags,
  AssignOrdersToUsers,
  DeassignOrdersToUsers,
  GetTagPriorityList,
  GetAllUsers,
  ResetSearchOrderData,
  UpdateOrderInfo,
  CreateOrder,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderSearchList);
